var indentation_default = {
  "indentZero": "rp3R4",
  "indentOne": "_3hekh",
  "indentTwo": "dDu46",
  "indentThree": "_0HWbg",
  "indentFour": "KLaOl",
  "indentFive": "_1BmIw",
  "indentSix": "_8Bl6w"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
